module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAARCAYAAAAyhueAAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOtJREFUeNq0VO0NgjAUfLywACvICDpCGcEVcAQcwRVwBB1BR8ARYAQ7Qn1NruSFEKgWL7n+6Mf1+j6aOedIsBcWlI6X0JKI1m47dMIik+EBl+dEl/61F2GVq8lnougYPla3mETReirqcYP4L2i1KVZZG4SdvjHyyeHMdSpqfYCx0IIxiemFO5y9jys++yCBtS4PNU8rewzmDM848G4PcNDPxDm8JOyzUwFe6IxSxbkRHlX8TuAs8oWYhTg3KGrCJdVaTfNKMiw6LYPzMqZJ+IvyGWI3Mv0DUgLNhr/UO/xSoW+3+E99AwwfAQYA7FwYsHNFhbAAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./public/img/icons/icon-envelope.png
// module id = 90
// module chunks = 0